import React, { useState, useEffect, useRef } from "react";

//design imports from material
import {
  Grid,
  FormLabel,
  TextField,
  Typography,
  Button,
  FormControl,
} from "@mui/material";

//layout import
import Layout from "../../layout/Layout";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";

//form imports
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import StateList, { stateList } from "../../components/StateList";

//date picker
import dayjs from "dayjs";

import axios from "axios";
import { config, manageCompaniesAPI } from "../../config";
import { AlertMessage } from "../../components/AlertMessage";
import { useParams, useNavigate } from "react-router-dom";
import NavigationGuard from "../../layout/NavigationGuard";
// import { useNavigate } from "react-router-dom";

function ManageCoEdit() {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const validationSchema = Yup.object().shape({
    // txtCompanyName: Yup.string().required("Company Name is required"),
    // txtAddress: Yup.string().required("Address is required"),
    // txtCity: Yup.string().required("Town / City is required"),
    // txtState: Yup.string().required("State is required"),
    // intPincode: Yup.string().required("Pin Code is required"),
    // txtPrimaryPhoneNumber: Yup.string().required("Primary Contact is required"),
    // txtSecondaryPhoneNumber: Yup.string().required("Secondary Contact is required"),
    // txtEmailId: Yup.string().required("Email Id is required"),
    // txtWebsiteLink: Yup.string().required("Website URL is required"),
    // txtPanNo: Yup.string().required("PAN Number is required"),
    // txtGstNo: Yup.string().required("GST Number is required"),
    // txtTanNo: Yup.string().required("TAN Number is required"),
    // txtBankName: Yup.string().required("Bank Name is required"),
    // txtBranch: Yup.string().required("Branch Name is required"),
    // txtAccountName: Yup.string().required("Account Name is required"),
    // txtAccountNo: Yup.string().required("Account Number is required"),
    // txtIfscCode: Yup.string().required("IFSC Code is required"),
  });

  const [stateName, setStateName] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");

  

  const [baseImage, setBaseImage] = useState("");

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  function onSubmit(data) {
    data.intType = 2;
    data.intCompanyId = companyId;
    data.txtState = stateName;
    data.txtCoLogo = baseImage;

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = manageCompaniesAPI;
  
    axios(config)
      .then(function (response) {
        
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        setTimeout(function () {
          navigate("/manage-companies/list");
        }, 2000);

       
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      const data = JSON.stringify({
        intCompanyId: parseInt(companyId),
        intType: 4,
      });

      config.method = "POST";
      config.data = data;
      config.url = manageCompaniesAPI;

      axios(config)
        .then(function (response) {
          setStateName(response.data.result);
          handleFormReset(response.data.result[0]);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const handleFormReset = (data) => {
    let defaultValues = {};
    setStateName(data.state);
    setBaseImage(data.company_logo);
    defaultValues.txtCompanyName = data.company_name;
    defaultValues.txtAddress = data.address;
    defaultValues.txtCity = data.city;
    // defaultValues.txtState = data.state;
    defaultValues.intPincode = data.pincode;
    defaultValues.txtPrimaryPhoneNumber = data.primary_contact;
    defaultValues.txtSecondaryPhoneNumber = data.secondary_contact;
    defaultValues.txtEmailId = data.email_id;
    defaultValues.txtWebsiteLink = data.website_link;
    defaultValues.txtGstNo = data.gst_no;
    defaultValues.txtPanNo = data.pan_no;
    defaultValues.txtTanNo = data.tan_no;
    defaultValues.txtBankName = data.bank_name;
    defaultValues.txtBranch = data.branch;
    defaultValues.txtAccountNo = data.account_number;
    defaultValues.txtAccountName = data.account_name;
    defaultValues.txtIfscCode = data.ifsc_code;
    reset({ ...defaultValues });
  };

  const childRef = useRef();

  return (
    <>
      <Layout>
        <Grid className="employee-form">
          <AlertMessage ref={childRef} />
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                Edit Company
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">Company</Typography>
                <Typography color="text.primary">Edit</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="secondary"
                className="button_first"
                href="/manage-companies/list"
              >
                List Company
              </LoadingButton>
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>

          <form className="form_design" onSubmit={handleSubmit(onSubmit)}>
            {/* Company Name & Address */}
            <h3>Company Name & Address</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-simple-select-label">
                  Company Name
                </InputLabel> */}
                  <TextField
                    name="txtCompanyName"
                    type="text"
                    label="Company Name"
                    fullWidth
                    focused
                    {...register("txtCompanyName")}
                    error={errors.txtCompanyName ? true : false}
                    helperText={errors.txtCompanyName?.message}
                  />
                </FormControl>
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="address"
                  type="text"
                  label="Street Address"
                  fullWidth
                  focused
                  {...register("txtAddress")}
                  error={errors.txtAddress ? true : false}
                  helperText={errors.txtAddress?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="city"
                  type="text"
                  label="Town / City"
                  fullWidth
                  focused
                  {...register("txtCity")}
                  error={errors.txtCity ? true : false}
                  helperText={errors.txtCity?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">State</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={stateName}
                    label="State"
                    focused
                    onChange={(e) => {
                      setStateName(e.target.value);
                      setValue("txtState", e.target.value);
                    }}
                  >
                    {stateList.map((row) => (
                      <MenuItem value={row.state_name}>
                        {row.state_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Pincode"
                  type="number"
                  label="Pincode"
                  fullWidth
                  focused
                  {...register("intPincode")}
                  error={errors.intPincode ? true : false}
                  helperText={errors.intPincode?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Primary phone number"
                  type="text"
                  label="Primary Contact Number"
                  fullWidth
                  focused
                  {...register("txtPrimaryPhoneNumber")}
                  error={errors.txtPrimaryPhoneNumber ? true : false}
                  helperText={errors.txtPrimaryPhoneNumber?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Secondary phone number"
                  type="text"
                  label="Secondary phone number"
                  fullWidth
                  focused
                  {...register("txtSecondaryPhoneNumber")}
                  error={errors.txtSecondaryPhoneNumber ? true : false}
                  helperText={errors.txtSecondaryPhoneNumber?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Company email id"
                  type="text"
                  label="Company Email Id"
                  fullWidth
                  focused
                  {...register("txtEmailId")}
                  error={errors.txtEmailId ? true : false}
                  helperText={errors.txtEmailId?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Website Link"
                  type="text"
                  label="Website Link"
                  fullWidth
                  focused
                  {...register("txtWebsiteLink")}
                  error={errors.txtWebsiteLink ? true : false}
                  helperText={errors.txtWebsiteLink?.message}
                />
              </Grid>
            </Grid>

            {/* Business details */}
            <h3>Business Details</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="gstNo"
                  type="text"
                  label="GST No."
                  fullWidth
                  focused
                  {...register("txtGstNo")}
                  error={errors.txtGstNo ? true : false}
                  helperText={errors.txtGstNo?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="panNo"
                  type="text"
                  label="PAN No."
                  fullWidth
                  focused
                  {...register("txtPanNo")}
                  error={errors.txtPanNo ? true : false}
                  helperText={errors.txtPanNo?.message}
                />
              </Grid>
            </Grid>
            <div className="empty-space-20"></div>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="tanNo"
                  type="text"
                  label="TAN No."
                  fullWidth
                  focused
                  {...register("txtTanNo")}
                  error={errors.txtTanNo ? true : false}
                  helperText={errors.txtTanNo?.message}
                />
              </Grid>
            </Grid>

            {/* Bank details */}
            <h3>Bank Details</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="bank_name"
                  type="text"
                  label="Bank Name"
                  fullWidth
                  focused
                  {...register("txtBankName")}
                  error={errors.txtBankName ? true : false}
                  helperText={errors.txtBankName?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="branch"
                  type="text"
                  label="Branch"
                  fullWidth
                  focused
                  {...register("txtBranch")}
                  error={errors.txtBranch ? true : false}
                  helperText={errors.txtBranch?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="account_no"
                  type="number"
                  label="Account Number"
                  fullWidth
                  focused
                  {...register("txtAccountNo")}
                  error={errors.txtAccountNo ? true : false}
                  helperText={errors.txtAccountNo?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="account_name"
                  type="text"
                  label="Account Name"
                  fullWidth
                  focused
                  {...register("txtAccountName")}
                  error={errors.txtAccountName ? true : false}
                  helperText={errors.txtAccountName?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="ifsc_code"
                  type="text"
                  label="IFSC Code"
                  fullWidth
                  focused
                  {...register("txtIfscCode")}
                  error={errors.txtIfscCode ? true : false}
                  helperText={errors.txtIfscCode?.message}
                />
              </Grid>
            </Grid>

            {/* Logo Part */}
            <h3>ADD LOGO</h3>
            <Grid item className="avatar-profile" alignItems="left">
              <Grid alignItems="center">
                <Grid className="profile_upload">
                  <Button variant="contained" component="label">
                    Upload
                    <input
                      {...register("txtCoLogo")}
                      onChange={(e) => {
                        uploadImage(e);
                      }}
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                    />
                  </Button>
                </Grid>
                <img className="company_avatar_img" src={baseImage} alt="" />
                <h5 color="black">Upload Company Logo</h5>
                <Typography className="note">
                  Allowed *.jpeg, *.jpg, *.png
                </Typography>
              </Grid>
            </Grid>

            {/* Button */}
            <Grid container className="submit-button" alignItems="center">
              <Grid item xs={12} lg={12} md={12}>
                <LoadingButton
                  size="large"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={formState.isSubmitting}
                >
                  Submit
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
        <>
      <NavigationGuard/>
    </>
      </Layout>
    </>
  );
}

export default ManageCoEdit;
